import React, { FC, useEffect } from 'react';
import { Message, Heading } from '@edreamsodigeo/prisma-design-system';
import {
  usePerformedSearchRequest,
  useNumberOfPassengers,
} from 'clientState/providers/SearchRequestProvider';
import { useTransportTypeProduct } from '@components/Filters/Components/TransportTypeFilter/Provider';
import { useTranslation, useTracking } from '@edreamsodigeo/frontend-core';
import { shallShowTicketsLeft } from 'clientState/utilsHelper';

export const TICKETS_LIMIT = {
  MIN: 0,
  MAX: 10,
};

export type TicketsLeftProps = {
  ticketsNumber?: number;
};

export const TicketsLeftMessage: FC<TicketsLeftProps> = ({ ticketsNumber }) => {
  const { t } = useTranslation();
  const numPassengers = useNumberOfPassengers();
  const key =
    numPassengers === ticketsNumber
      ? t('results.ticketsLeft.lastTickets', { count: ticketsNumber })
      : t('results.ticketsLeft.message', { count: ticketsNumber || 0 });

  return <>{key}</>;
};

const TextComponent: FC = ({ children }) => (
  <Heading weight="medium" type="6">
    {children}
  </Heading>
);

const TicketsLeft: FC<TicketsLeftProps> = ({ ticketsNumber = 0 }) => {
  const searchRequest = usePerformedSearchRequest();
  const { trackEvent } = useTracking();
  const { product } = useTransportTypeProduct();
  const shallShow = shallShowTicketsLeft(ticketsNumber) && product !== 'TRAIN';

  useEffect(() => {
    if (shallShow) {
      trackEvent({
        action: 'seats_left',
        label: `seats_left:${ticketsNumber}`,
      });
    }
  }, [shallShow, trackEvent, ticketsNumber]);

  return shallShow && searchRequest ? (
    <Message type="persuasive">
      <TextComponent>
        <TicketsLeftMessage ticketsNumber={ticketsNumber} />
      </TextComponent>
    </Message>
  ) : null;
};

export default TicketsLeft;
